import getSelectedFolderView from '../../selectors/getSelectedFolderView';
import selectTodoById from '../../selectors/selectTodoById';
import Todo from '../../store/schema/Todo';
import { TasksCustomData } from '../../datapoints';

export default function getTasksCustomData(): TasksCustomData {
    return {
        activeTasks: countTodos(activeTodo),
        activeTasksWithDueDate: countTodos(activeTodoWithDueDate),
        activeTasksWithReminders: countTodos(activeTodoWithReminder),
    };
}

type todoFilter = (task: Todo) => boolean;

function countTodos(filter: todoFilter): number {
    const folderView = getSelectedFolderView();
    const todos = folderView
        ? folderView.activeTaskIds.map(id => selectTodoById(id)).filter(item => !!item)
        : [];
    return todos.reduce(function(count: number, t: Todo) {
        return filter(t) ? count + 1 : count;
    }, 0);
}
const activeTodo = (task: Todo) => task.Status !== 'Completed';
const activeTodoWithDueDate = (task: Todo) => (activeTodo(task) && task.DueDateTime ? true : false);
const activeTodoWithReminder = (task: Todo) =>
    activeTodo(task) && task.ReminderDateTime ? true : false;
